// Campus photo for /colleges/university-of-iowa: CC BY 2.0, by Tony Webster from Minneapolis, Minnesota, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AIowa_Old_Capitol_Museum%2C_Iowa_City_-_University_of_Iowa_(42696029261).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-iowa/; credited under the photo.
const photo = {
    "slug": "university-of-iowa",
    "alt": "The Old Capitol and its gold dome on the Pentacrest at the University of Iowa in Iowa City",
    "src": "/colleges/university-of-iowa/campus-1600.webp",
    "srcSmall": "/colleges/university-of-iowa/campus-800.webp",
    "srcMid": "/colleges/university-of-iowa/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-iowa/og.jpg",
    "title": "Iowa Old Capitol Museum, Iowa City - University of Iowa (42696029261)",
    "author": "Tony Webster from Minneapolis, Minnesota, United States",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AIowa_Old_Capitol_Museum%2C_Iowa_City_-_University_of_Iowa_(42696029261).jpg",
    "read": "2026-10-01"
};

export default photo;
